import { useNavigate } from 'react-router-dom';

// styles
import {
    TokenRedemptionEntryContainer,
    LeftContent,
    DateDisplay,
    ActionDisplay,
    TokenCountDisplay,
    TokenCount
  } from './TokenRedemptionEntry.styles';
  
  // assets
  import tokenIcon from '../../../../assets/system/icons/pullvault-token.png';
  
  // components
  import CardAttribute from '../../../../components/card-attribute/CardAttribute';
  
  export default function TokenRedemptionEntry({ content }) {
    const navigate = useNavigate();
    const { details, actionType } = content || {};
    
    // Safely extract values with fallbacks
    const prevCount = details?.prevCount || 0;
    const newCount = details?.newCount || 0;
    
    const series = details?.series;
    const promoCode = details?.promoCode;
    const tokensAdded =
      details?.tokensAdded ??
      (actionType === 'promoCodeRedeemed' && newCount > prevCount
        ? newCount - prevCount
        : null);
    const sport = details?.sport;
    const year = details?.year;
    const manufacturer = details?.manufacturer;
    
    // Safely format timestamp
    const formattedTimestamp = content?.timestamp?.toDate?.()?.toLocaleString() || 'Unknown time';
  
    // Generate display text based on what was redeemed
    const getActionDisplayText = () => {
      if (actionType === 'welcomeTokensGranted') {
        const amountPart =
          tokensAdded != null && tokensAdded > 0
            ? ` (+${tokensAdded} token${tokensAdded === 1 ? '' : 's'})`
            : '';
        return details?.referral
          ? `Welcome bonus${amountPart}, including referral`
          : `Welcome bonus${amountPart}`;
      }
      if (actionType === 'promoCodeRedeemed' || promoCode) {
        const codePart = promoCode ? `: ${promoCode}` : '';
        const amountPart =
          tokensAdded != null && tokensAdded > 0
            ? ` (+${tokensAdded} token${tokensAdded === 1 ? '' : 's'})`
            : '';
        return `Promo Code Redeemed${codePart}${amountPart}`;
      }
      if (series) {
        return 'Checklist Unlocked:';
      }
      return 'Tokens Redeemed';
    };

    // Handle checklist navigation
    const handleChecklistClick = () => {
      if (sport && year && manufacturer && series) {
        navigate(`/checklists/${sport}/${year}/${manufacturer}/${series}`);
      }
    };
  
    return (
      <TokenRedemptionEntryContainer className='widget-bg'>
        <LeftContent>
          <DateDisplay>{formattedTimestamp}</DateDisplay>
          <ActionDisplay>
            <span>{getActionDisplayText()}</span>
            {series && (
              <div 
                onClick={handleChecklistClick}
                style={{ cursor: sport && year && manufacturer ? 'pointer' : 'default' }}
              >
                <CardAttribute text={series} size="S" color="#FFFFFF"/>
              </div>
            )}
          </ActionDisplay>
        </LeftContent>
        <TokenCountDisplay>
          <TokenCount style={{ opacity: 0.5 }}>
            <h4>{prevCount}</h4>
          </TokenCount>
          <span>&#x279F;</span>
          <TokenCount>
            <h4>{newCount}</h4>
            <img src={tokenIcon} alt="token icon" />
          </TokenCount>
        </TokenCountDisplay>
      </TokenRedemptionEntryContainer>
    );
  } 